import { sum } from 'lodash';

export default {
  methods: {
    getIntFormat(num, useNegative) {
      if (useNegative && num) {
        return parseInt(num, 10);
      }

      if (num && num > 0) {
        return parseInt(num, 10);
      }

      return 0;
    },

    getRatio(num, total) {
      if (total === 0) {
        return 0;
      }

      return (num / total) * 100;
    },

    getSum(numList) {
      return sum(numList);
    },

    getToCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getFormatCount(count) {
      const firsrtLimit = 10000;
      const secondLimit = 100000000;

      if (count >= firsrtLimit && count < secondLimit) {
        return `${(count / firsrtLimit).toFixed(0)}만`;
      }

      if (count >= secondLimit) {
        return `${(count / secondLimit).toFixed(0)}억`;
      }

      return count;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/numbers.js